import { COLORS } from '@constants';
import { Icon } from '@ui';
import styled from 'styled-components';

export const StyledCrossIcon = styled(Icon.CloseIcon)`
    &:hover {
        color: ${COLORS.$gray60Black};
    }
`;
